// extracted by mini-css-extract-plugin
module.exports = {"icon":"_a93ec49"};